import { collection, getDocs, query, where, orderBy } from 'firebase/firestore';
import Failure from '../../../core/Failure';
import { FirestoreCollections, firestore } from '../../../firebase.config';
import Scenario from '../../models/Scenario';

async function getScenariosByDomainId(
  domainId: string
): Promise<{ scenarios: Scenario[] }> {
  try {
    const db = firestore;
    const scenariosCollection = collection(db, FirestoreCollections.scenarios);

    const scenariosQuery = query(
      scenariosCollection,
      where('id_domain', '==', domainId),
      orderBy('name')
    );

    const results = await getDocs(scenariosQuery);

    const scenarios: Scenario[] = results.docs.map((doc) =>
      Scenario.fromFirestore(doc)
    );

    return {
      scenarios,
    };
  } catch (e) {
    console.log('error: ', e);
    throw new GetScenariosByDomainIdFailure();
  }
}

export class GetScenariosByDomainIdFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default getScenariosByDomainId;
